import LargeViewMenu from './LargeViewMenu';

export default LargeViewMenu;
